@if (isVisible) {
  <div class="oa-sticky-footer text-center">
    @for (item of buttonConfiguration; track item) {
      <button class="btn btn-primary btn-round " name="{{ item.name }}" (click)="onButtonClick($event, item)">
        {{ item.label }}
      </button>
    }
  </div>
}
